import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";
import RoutesList from "./RoutesList";
import Page404 from "./Page404";
import DefaultLayout from "./PageLayout/DefaultLayout";

/**
 * Export a component that collect all private routes(start page, documents and etc.).
 */

const RenderRoutes = ({ userData }) => {
  /**
   * Use <Switch/> to catch all routes,
   * send corect component or 404 page if route does not exist.
   */
  return (
    <Switch>
      <Route
        exact
        path="/"
        component={() => (
          <Redirect
            push
            to={
              userData.id ? `/documents/${userData.services[0].id}/0` : "/login"
            }
          />
        )}
      />
      {RoutesList.map((route, index) => (
        <Route
          exact
          key={index}
          path={route.path}
          component={(props) => {
            if (route.type === "private" && userData.id) {
              return (
                <DefaultLayout {...props}>
                  <route.component {...props} />
                </DefaultLayout>
              );
            } else if (route.type === "public" && !userData.id) {
              return <route.component {...props} />;
            } else if (route.type === "redirect") {
              return <route.component {...props} />;
            } else {
              return <Redirect push from={route.path} to="/" />;
            }
          }}
        />
      ))}
      <Route component={Page404} />
    </Switch>
  );
};

/**
 * Take userData from redux store and return it
 * in components props.
 */
const mapStateToProps = ({ userData }) => ({ userData });

export default connect(mapStateToProps)(RenderRoutes); //Export component and connect it with redux.
